import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateCompiler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'environments/environment';
import * as moment from 'moment';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppConfig } from './app.config';
import { BasketComponent } from './components';
import { CoreModule } from './core/core.module';
import { ConfirmPage, ContactPage, CoursesPage, ErrorPage, OrderPage, PaymentPage, ThanksPage } from './pages';
import { SharedModule } from './shared/shared.module';

export function initConfig(config: AppConfig): any {
  return () => config.load();
}

@NgModule({
  declarations: [
    AppComponent,
    BasketComponent,
    ConfirmPage,
    ContactPage,
    CoursesPage,
    OrderPage,
    PaymentPage,
    ErrorPage,
    ThanksPage
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    CoreModule,
    SharedModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler
      }
    })
  ],
  providers: [
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [AppConfig],
      multi: true
    },
    { provide: 'API_URL', useValue: environment.viper.apiUrl },
    { provide: 'API_KEY', useValue: environment.viper.apiKey },
    { provide: 'BACKEND_URL', useValue: environment.backendUrl },
    { provide: 'BUCKAROO_URL', useValue: environment.buckaroo.url },
    { provide: 'BUCKAROO_SECRET', useValue: environment.buckaroo.secretKey },
    { provide: 'BUCKAROO_WEBSITEKEY', useValue: environment.buckaroo.websiteKey }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    moment.locale('nl');
  }
}

// Required for AOT compilation.
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
